<template>
  <div class="hr-project-finance">
    <page-header title="FINANCE">
      <template #action>
        <v-btn
          :to="{ name: 'hr-project-show', params: { id: projectId } }"
          link
          color="button"
          class="fw-400"
        >
          BACK
        </v-btn>
      </template>
      <template #breadcrumbs>
        <router-link :to="{ name: 'hr-projects' }">
          Projects
        </router-link>
        <span>/</span>
        <router-link :to="{ name: 'hr-project-show', params: { id: projectId } }">
          <span v-if="projectFinance.navigation">
            {{ projectFinance.navigation.project.name }}
          </span>
          <span v-else>
            Project
          </span>
        </router-link>
        <span>/ Finance</span>
      </template>
    </page-header>

    <div class="hr-project-finance__summary">
      <ProjectMonthlyFinanceSummary
        :current-month="projectFinance.current_month"
        :available-months="projectFinance.months"
        :summary="projectFinance.summary"
        @change="changeDate"
      />
    </div>

    <MembersReportsTableCard
      :current-month="projectFinance.current_month"
      :reports="projectFinance.reports"
      @update="fetchProjectFinance(projectParams)"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import MembersReportsTableCard from '@/components/HrProjects/Finance/MembersReportsTableCard.vue';
import ProjectMonthlyFinanceSummary from '@/components/ProjectMonthlyFinanceSummary.vue';

export default {
  metaInfo: {
    title: 'Project finance',
  },

  components: {
    PageHeader,
    MembersReportsTableCard,
    ProjectMonthlyFinanceSummary,
  },

  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      currentDate: null,
    };
  },

  computed: {
    ...mapState('hrProject', [
      'projectFinance',
      'navigation',
    ]),

    projectParams() {
      return {
        id: this.projectId,
        date: this.currentDate,
      };
    },
  },

  created() {
    this.fetchProjectFinance(this.projectParams);
  },

  methods: {
    ...mapActions('hrProject', [
      'fetchProjectFinance',
    ]),

    changeDate(date) {
      this.currentDate = date;

      this.fetchProjectFinance(this.projectParams);
    },
  },
};
</script>

<style lang="scss" scoped>
.hr-project-finance {
  &__summary {
    margin-bottom: 16px;
  }
}
</style>
